import axios from "axios";
import { BASE_URL } from "../config";

async function getCategories() {
  return await axios.get(BASE_URL + "categories.json", {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "X-Requested-With",
      "Access-Control-Allow-Credentials": true,
      "Content-Type": "application/json",
    },
  });
}

async function getCategorie(id) {
  return await axios.get(BASE_URL + "categories/" + id + ".json");
}

export { getCategories, getCategorie };
